// First-party mirror of window.Fides.consent, written by client JS on
// FidesInitialized / FidesUpdated. Middleware and other server-side code read
// this cookie instead of `fides_consent` because Fides only writes its own
// cookie once the user acknowledges the consent modal — this one is written
// as soon as Fides has resolved defaults, and updated on every change.

export const PELOTON_CONSENT_COOKIE_NAME = 'peloton_consent';

// One year — matches Fides' own retention posture and gives cross-tab / repeat
// visitors a stable server-visible value between sessions.
const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;

export type PelotonConsent = {
  functional?: boolean;
  social_media?: boolean;
  marketing?: boolean;
  analytics?: boolean;
  strictly_necessary?: boolean;
};

export const parsePelotonConsent = (raw: string | undefined): PelotonConsent | null => {
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    return parsed && typeof parsed === 'object' ? (parsed as PelotonConsent) : null;
  } catch {
    return null;
  }
};

export const writePelotonConsentCookie = (consent: PelotonConsent): void => {
  if (typeof document === 'undefined') {
    return;
  }
  const value = encodeURIComponent(JSON.stringify(consent));
  document.cookie = `${PELOTON_CONSENT_COOKIE_NAME}=${value}; max-age=${ONE_YEAR_IN_SECONDS}; path=/; samesite=lax; secure`;
};
